module.exports = __webpack_public_path__ + "static/media/sync.0f29df18.svg";


//////////////////
// WEBPACK FOOTER
// ../images/sync.svg
// module id = 667
// module chunks = 0